import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import TestimonyPage from './components/TestimonyPage';
import NavBar from './components/NavBar';
import BottomBar from './components/BottomBar';
import HomePage from './pages/Home';
import ResumePage from './pages/Resume';
import Calendar from './components/Calendar';
import SubscriptionForm from './components/SubscriptionForm';
import SystematicsI from './pages/SystematicsI';
import SystematicsII from './pages/SystematicsII';
import SystematicsIII from './pages/SystematicsIII';
import OTFoundations from './pages/OTFoundations';
import NTFoundations from './pages/NTFoundations';
import Ethics from './pages/Ethics';
import Needs from './components/Needs';
import Exegesis from './pages/Exegesis';
import Latin from './pages/Latin';
import Hebrew from './pages/Hebrew';
import ResourcePage from './components/ResourcePage';
import Resource1 from './pages/Resource1';
import About from './pages/About';
import Contact from './pages/Contact';
import ComingSoon from './pages/ComingSoon';
import { LanguageContext } from "./LanguageContext";
const apiBase = process.env.REACT_APP_API_URL || '';

function CalendarPage() {
  return (
    <div>
      <NavBar />
      <div className="page-content">
        <Calendar />
      </div>
      <BottomBar />
    </div>
  );
}

function Home() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

function NeedsPage() {
  return (
    <div>
      <div>
        <Needs />
      </div>
    </div>
  );
}

function Testimonies() {
  return (
    <div>
      <NavBar />
      <div>
        <TestimonyPage />
      </div>
      <SubscriptionForm />
      {/* <BottomBar /> */}
    </div>
  );
}

function HW() {
  return (
    <div>
      <NavBar />
      <div>
        <h3>H. Wang</h3>
      </div>
      {/* <BottomBar /> */}
    </div>
  );
}


function TestBackend() {
  const [message, setMessage] = useState('');

  // Step 3: Fetch data from '/api/hello' when the component loads
  useEffect(() => {
    fetch(`${apiBase}/api/hello`)
      .then(response => response.json())
      .then(data => {
        setMessage(data.message); // Set the message in state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <div>
      <a>Hello</a>
      <a>{message}</a>
    </div>
  );
}

function Resume() {
  return (
    <div>
      <NavBar />
      <div className="page-content">
        <ResumePage />
      </div>
      {/* <BottomBar /> */}
    </div>
  );
}

function SubscriptionPage() {
  return (
    <div>
      <NavBar />
      <div className="page-content">
        <SubscriptionForm />
      </div>
      {/* <BottomBar /> */}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calendar" element={<CalendarPage />} />
        {/* <Route path="/testimonial" element={<Testimonial />} /> */}
        <Route path="/systematics/1" element={<SystematicsI />} />
        <Route path="/systematics/2" element={<SystematicsII />} />
        <Route path="/systematics/3" element={<SystematicsIII />} />
        <Route path="/otfoundations" element={<OTFoundations />} />
        <Route path="/ntfoundations" element={<NTFoundations />} />
        {/* <Route path="/ethics" element={<Ethics />} /> */}
        <Route path="/needs" element={<NeedsPage />} />
        <Route path="/testimonies" element={<Testimonies />} />
        <Route path="/testimonies" element={<Testimonies />} />
        <Route path="/exegesis" element={<Exegesis />} />
        <Route path="/latin" element={<Latin />} />
        <Route path="/hebrew" element={<Hebrew />} />
        <Route path="/resource1" element={<Resource1 />} />
        {/* <Route path="/hwang" element={<HW />} /> */}
        <Route path="/resume" element={<Resume />} />
        <Route path="/subscribe" element={<SubscriptionPage />} />
        <Route path="/resources" element={<ResourcePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
}

export default App;